import AboutCoursesSvg from "../svg/AboutCoursesSvg";
import AboutMaltaSvg from "../svg/AboutMaltaSvg";
import AboutUsSvg from "../svg/AboutUsSvg";
import Admissions from "../svg/Admissions";

export const navigationConst = {
  title: "Navigation MSMB",
  data: [
    {
      id: "about-us",
      text: "About US",
      image: AboutUsSvg,
    },
    {
      id: "about-malta",
      text: "About Malta",
      image: AboutMaltaSvg,
    },
    {
      id: "about-courses",
      text: "About Courses",
      image: AboutCoursesSvg,
    },
    {
      id: "admissions-1",
      text: "Admissions",
      link: "/admissions",
      image: Admissions,
    },
    {
      id: "admissions-2",
      text: "Admissions",
      link: "/admissions",
      image: Admissions,
    },
    {
      id: "admissions-3",
      text: "Admissions",
      link: "/admissions",
      image: Admissions,
    },
    {
      id: "admissions-4",
      text: "Admissions",
      link: "/admissions",
      image: Admissions,
    },
  ],
};

export const navigationDynamicConst = [
  {
    id: "about-us",
    title: "About US",
    data: [
      {
        id: "about-us-university",
        text: "About Us University",
        image: AboutUsSvg,
        link: "/about-us-university",
      },
      {
        id: "about-us-welcome-words",
        text: "About Us Welcome Words",
        image: AboutUsSvg,
        link: "/about-us-welcome-words",
      },
    ],
  },
  {
    id: "about-malta",
    title: "About Malta",
    data: [
      {
        id: "about-malta-university",
        text: "About Matla University",
        image: AboutMaltaSvg,
        link: "/about-malta-university",
      },
      {
        id: "about-malta-welcome-words",
        text: "About Malta Welcome Words",
        image: AboutMaltaSvg,
        link: "/about-malta-welcome-words",
      },
    ],
  },
  {
    id: "about-courses",
    title: "About courses",
    data: [
      {
        id: "about-courses-university",
        text: "About Courses University",
        image: AboutCoursesSvg,
        link: "/about-courses-university",
      },
      {
        id: "about-courses-welcome-words",
        text: "About Courses Welcome Words",
        image: AboutCoursesSvg,
        link: "/about-courses-welcome-words",
      },
    ],
  },
];
